import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import rootReducer from '../Redux/rootReducers'; // Assuming you have a rootReducer

// Configuration for redux-persist
const persistConfig = {
  key: 'root',  // Key for the localStorage entry
  storage,  // Storage method (localStorage in this case)
  whitelist: ['email', 'login', 'dashboard', 'userData', 'registration', 'docusign', 'sso', 'ssoQueryParamsDetails', 'fromLogin']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store with the persisted reducer
const store = createStore(persistedReducer);

// Create a persistor for the store
const persistor = persistStore(store);

export { store, persistor };
